export var BOOKING_CHANNEL = function (BOOKING_CHANNEL) {
  BOOKING_CHANNEL["PI"] = "PI";
  BOOKING_CHANNEL["CCUI"] = "CCUI";
  BOOKING_CHANNEL["BB"] = "BB";
  return BOOKING_CHANNEL;
}({});